export default __webpack_public_path__ + "static/media/mail.2710a236.svg";